import client from '../httpClient';

const lineUpdateIdApi = (lineRoomLinkId, param) => {
  return client.put(`/line-rooms/${lineRoomLinkId}`, JSON.stringify(param));
};

export default lineUpdateIdApi;
